// ============================================================================
// OBT — Merkezi API katmanı
// ============================================================================
// Mevcut paylaşılan istemci (`src/api/client.js`) kullanılır. Yeni bir HTTP
// istemcisi kurulmaz, ikinci bir base URL tanımlanmaz.
//
// PREFIX: `apiClient` zaten `${BACKEND_URL}/api` ile yapılandırılmıştır.
// Backend OBT router'ı hem `/api/obt` hem `/api/v1/obt` altında mount edilir
// (server.py: include_router(obt_router, prefix="/api") ve prefix="/api/v1").
// Uygulamanın kanonik tercihi `/api` olduğu için OBT de YALNIZ onu kullanır.
// 404 alındığında diğer prefix'e düşen bir fallback KURULMAZ.
//
// F1 kapsamında yalnız iskeletin ihtiyaç duyduğu okuma uçları bağlanmıştır.
// F2-F4'te ilgili uçlar bu dosyaya eklenecektir.
// ============================================================================

import apiClient from '@/api/client';

const OBT_BASE = '/obt';

/**
 * Kampanya listesi + sayaçları.
 * GET /api/obt/campaigns
 * Yanıt: { page: {limit, offset, total, has_more}, items: CampaignHistoryOut[] }
 *
 * Kapsam backend'de ChainService ile çözülür; frontend park/personel filtresi
 * göndererek kapsam genişletemez.
 */
export async function fetchObtCampaigns(
  { topic, status, parkId, onlyLate, limit, offset } = {},
  { signal } = {}
) {
  const params = {};
  if (topic) params.topic = topic;
  if (status) params.status = status;
  if (parkId) params.park_id = parkId;
  if (onlyLate) params.only_late = true;
  if (typeof limit === 'number') params.limit = limit;
  if (typeof offset === 'number') params.offset = offset;

  const res = await apiClient.get(`${OBT_BASE}/campaigns`, { params, signal });
  return res.data;
}

/**
 * Tek kampanya özeti (tüm sayaç bloğunu içerir).
 * GET /api/obt/campaigns/{campaign_id}
 * Kapsam dışında ise backend 404 döner (varlık bilgisi sızdırılmaz).
 */
export async function fetchObtCampaign(campaignId, { signal } = {}) {
  const res = await apiClient.get(
    `${OBT_BASE}/campaigns/${encodeURIComponent(campaignId)}`,
    { signal }
  );
  return res.data;
}

// ---------------------------------------------------------------------------
// İnceleme kuyrukları — her rol YALNIZ kendi kuyruğunu çağırır.
// Yanıt: ReviewQueueItem[] (sayfalama yok, backend kapsamla sınırlar).
// ---------------------------------------------------------------------------

export async function fetchObtBmQueue(params = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT_BASE}/review/bm-queue`, {
    params,
    signal,
  });
  return res.data;
}

export async function fetchObtMyQueue(params = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT_BASE}/review/my-queue`, {
    params,
    signal,
  });
  return res.data;
}

export async function fetchObtDirectorQueue(params = {}, { signal } = {}) {
  const res = await apiClient.get(`${OBT_BASE}/review/director-queue`, {
    params,
    signal,
  });
  return res.data;
}

/** Rol → kuyruk çağrısı eşlemesi. Formen'in inceleme kuyruğu YOKTUR. */
export const OBT_QUEUE_FETCHERS = Object.freeze({
  director: fetchObtDirectorQueue,
  deputy: fetchObtMyQueue,
  engineer: fetchObtBmQueue,
});
